import React from 'react';
import useStyles from './Styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import StoreImg from './StoreImg';
import {Tools} from './Tools';
import {Owner} from './Inc';

interface Props {
    list: any[],
    owner: Owner,
    pager: any,
    jump(newPage:number):void,
}

const RequestListDetail = (props:Props)=> {
    const classes = useStyles();
	
	return (
		<div id="fav_list_search">
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableHeadNowrap} align='center'><Hidden mdDown implementation="js">買いたい！した</Hidden>日時</TableCell>
                        <Hidden mdDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap} align='center'>画像</TableCell>
                        </Hidden>
                        <TableCell className={classes.tableHeadNowrap} align='center'>商品名</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
            {props.list.map( (sale:any,index:number)=>{
                const key = "sale"+index;
                return (
                    <TableRow key={key}>
                        <TableCell sx={{verticalAlign:'middle',width:{md:'10em',sm:'6em'}}} className={classes.tableCellNowrap+" "+classes.tableCellDense} align='center'>
                            {sale.date}<br/>
                            {sale.time}<br/>
                        </TableCell>
                        <Hidden mdDown implementation="js">
                            <TableCell className={classes.tableCellDense} align='center' style={{width:'5em'}}><StoreImg owner_id={props.owner.owner_id} img_id={sale.img_id} thumb={true} className="imgList"/></TableCell>
                        </Hidden>
                        <TableCell className={classes.tableCellDense}>
							<span className={classes.itemId}>ID:{sale.item_id}</span><br/>
							{sale.item_name}<br/>
                        </TableCell>
                    </TableRow>
                );
            })}
                </TableBody>
            </Table>
            <div style={{padding:"1em"}}>
            {Tools.pager(props.pager,props.jump)}
            </div>


		</div>
	);
}

export default RequestListDetail;
